import Chat from './styled';

export default Chat;
